import * as React from "react";

function SvgStretch(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M3 16.4h14v2H3zM3 1.6h14v2H3zM10.6 12.8V7.2l1.3 1.3 1.1-.8-3-3-3 3 1.1.8 1.3-1.3v5.6l-1.3-1.3-1.1.8 3 3 3-3-1.1-.8z" /></svg>;
}

export default SvgStretch;